import React from "react";
import { FileSearch, FileText, Shield, AlertCircle, Eye, CheckCircle } from "lucide-react";

const ServicesSection = () => {
  const services = [
    {
      icon: <FileSearch />,
      title: "Trademark Search & Clearance",
      description: "Comprehensive trademark availability searches across federal, state, and common law databases. We identify potential conflicts early, saving you time and money by ensuring your mark is available before filing.",
      features: ["Federal database search", "State records review", "Common law analysis", "Detailed conflict report"],
    },
    {
      icon: <FileText />,
      title: "Trademark Application Filing",
      description: "Expert preparation and filing of your trademark application with the USPTO. We handle all paperwork, select appropriate classes, and ensure your application meets all federal requirements for the best chance of approval.",
      features: ["USPTO application prep", "Class selection guidance", "Specimen preparation", "Filing fee included"],
    },
    {
      icon: <Shield />,
      title: "Brand Protection & Strategy",
      description: "Develop a comprehensive trademark protection strategy tailored to your business. We advise on trademark selection, usage guidelines, and expansion strategies to maximize your brand's legal protection.",
      features: ["Strategic class selection", "Multi-jurisdiction planning", "Portfolio management", "Usage guidelines"],
    },
    {
      icon: <AlertCircle />,
      title: "Office Action Response",
      description: "Expert handling of USPTO office actions and objections. Our experienced attorneys craft persuasive legal arguments and amendments to overcome examiner objections and move your application toward registration.",
      features: ["Legal research & analysis", "Response drafting", "Amendment preparation", "Examiner communication"],
    },
    {
      icon: <Eye />,
      title: "Trademark Monitoring",
      description: "Continuous monitoring of new trademark filings to identify potential infringements. We watch for similar marks in your industry and alert you to potential threats to your brand before they become problems.",
      features: ["Weekly monitoring reports", "Infringement alerts", "Market surveillance", "Competitive intelligence"],
    },
    {
      icon: <CheckCircle />,
      title: "Maintenance & Renewals",
      description: "Never miss critical trademark deadlines. We track and file all required maintenance documents, including Sections 8, 15, and renewal applications, keeping your trademark protection active and enforceable.",
      features: ["Deadline tracking", "Maintenance filings", "Renewal applications", "Declaration of use"],
    },
  ];

  return (
    <section id="services" className="services-section">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Our Trademark Registration Services</h2>
          <p className="section-subtitle">
            Comprehensive Solutions for Complete Brand Protection
          </p>
        </div>

        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className="service-card">
              <div className="service-icon-wrapper">
                <div className="service-icon">{service.icon}</div>
              </div>
              <h3 className="service-title">{service.title}</h3>
              <p className="service-description">{service.description}</p>
              <ul className="service-features">
                {service.features.map((feature, idx) => (
                  <li key={idx} className="service-feature-item">
                    <CheckCircle className="feature-check" size={16} />
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
